import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import CardHeader from "@mui/material/CardHeader"
import Chip from "@mui/material/Chip"
import { forwardRef, useState } from "react"
import { useSelector } from "react-redux"

import Column from "../../../common/components/Column"
import Row from "../../../common/components/Row"
import A2PStatusPanel from "../a2p/A2PStatusPanel"
import { REGISTER_A2P_10DLC_DIALOG_CLOSE_REASONS } from "../components/RegisterA2P10DLCDialog"
import RegisterA2P10DLCDialogCombo from "../components/RegisterA2P10DLCDialogCombo"
import { selectCRMSettings } from "../reducer"
import { getSmsSendingPrerequisiteState } from "../utils"
import SettingsConnectionStatusRow from "./SettingsConnectionStatusRow"
import SetupRequiredStatusChip from "./SetupRequiredStatusChip"

const SmsConnectionSettingsCard = forwardRef(function SmsConnectionSettingsCard(
  { onStatusMessage },
  ref
) {
  const crmSettings = useSelector(selectCRMSettings)
  const smsPrereq = getSmsSendingPrerequisiteState(crmSettings)
  const [registerA2P10DLCDialogOpen, setRegisterA2P10DLCDialogOpen] =
    useState(false)
  const [
    brandRegistrationPendingDialogOpen,
    setBrandRegistrationPendingDialogOpen,
  ] = useState(false)

  function handleRegisterA2P10DLCDialogClosed(closeReason) {
    if (
      closeReason === REGISTER_A2P_10DLC_DIALOG_CLOSE_REASONS.brandRegPending
    ) {
      setBrandRegistrationPendingDialogOpen(true)
    } else if (
      closeReason ===
      REGISTER_A2P_10DLC_DIALOG_CLOSE_REASONS.createCampaignFinished
    ) {
      onStatusMessage?.(
        "Successfully registered your A2P campaign. You can now start sending SMS!"
      )
    }
    setRegisterA2P10DLCDialogOpen(false)
  }

  return (
    <>
      <Card ref={ref} variant="outlined" sx={{ width: "100%" }}>
        <CardHeader
          title="SMS messaging"
          titleTypographyProps={{ variant: "h6", fontWeight: 700 }}
          subheader="A2P 10DLC registration and campaign sending"
          sx={{
            textAlign: "left",
            alignItems: "flex-start",
            pb: 1,
            "& .MuiCardHeader-content": { overflow: "visible" },
          }}
          subheaderTypographyProps={{
            variant: "body2",
            sx: { textAlign: "left", mt: 0.5 },
          }}
        />
        <CardContent
          sx={{
            pt: 0,
            px: 2,
            pb: 2,
            "&:last-child": { pb: 2 },
          }}
        >
          <Column sx={{ gap: 2, alignItems: "stretch" }}>
            <SettingsConnectionStatusRow>
              <Row sx={{ alignItems: "center", minHeight: 32 }}>
                {smsPrereq.ready ? (
                  <Chip
                    label="Ready to send"
                    size="small"
                    sx={(theme) => ({
                      backgroundColor: theme.palette.success.main,
                      color: theme.palette.success.contrastText,
                      fontWeight: 600,
                    })}
                  />
                ) : (
                  <SetupRequiredStatusChip />
                )}
              </Row>
            </SettingsConnectionStatusRow>

            <A2PStatusPanel
              onContinueRegistration={() => setRegisterA2P10DLCDialogOpen(true)}
            />
          </Column>
        </CardContent>
      </Card>

      <RegisterA2P10DLCDialogCombo
        brandRegistrationPendingDialogOpen={brandRegistrationPendingDialogOpen}
        setBrandRegistrationPendingDialogOpen={
          setBrandRegistrationPendingDialogOpen
        }
        registerA2P10DLCDialogOpen={registerA2P10DLCDialogOpen}
        handleRegisterA2P10DLCDialogClosed={handleRegisterA2P10DLCDialogClosed}
      />
    </>
  )
})

export default SmsConnectionSettingsCard
